import React from 'react';
import { Button, Typography } from '@/ui-kit';
import styles from './intro.module.scss';
import BgImg from '@/assets/images/intro.png';
import WebApp from '@twa-dev/sdk';

export const IntroBanned: React.FC = () => {
    const openLink = () => {
        WebApp.openTelegramLink('https://t.me/euphora_support');
    };

    return (
        <section className={styles.intro}>
            <div className={styles.intro__deckor}>
                <img
                    className={styles.intro__deckor__img}
                    src={BgImg}
                    alt="background"
                />
            </div>
            <div className={styles.intro__content}>
                <Typography
                    className={styles.intro__Headline}
                    typeColor="white"
                    variant="h2"
                    center>
                    К сожалению, <br />вы были заблокированы
                </Typography>

                <Typography
                    typeColor="white"
                    variant="p"
                    className={styles.intro__text}
                    center>
                    Вы можете связаться с поддержкой
                </Typography>

                <div className={styles.intro__btn}>
                    <Button
                        isLink
                        variant="stretched"
                        onClick={openLink}>
                        @euphora_support
                    </Button>
                </div>
            </div>
        </section>
    );
};
